import { render, staticRenderFns } from "./about-improwised.vue?vue&type=template&id=1a91c81c&"
import script from "./about-improwised.vue?vue&type=script&lang=js&"
export * from "./about-improwised.vue?vue&type=script&lang=js&"
import style0 from "./about-improwised.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports